import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ConfirmationModal } from '../../../__legacy__/components/ConfirmationModal';

interface IProps {
  isOpened: boolean;
  onCanceled: () => void;
  onConfirmed: () => Promise<void>;
}

export const ResetWorkspacesModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <ConfirmationModal
      showModal={props.isOpened}
      onCancel={props.onCanceled}
      onConfirm={props.onConfirmed}
      confirmationHeader='reset_workspaces'
      confirmationQuestion={
        <div>
          <p>{t('reset_workspaces_confirmation_message')}</p>
          <ul>
            <li>{t('reset_list_1')}</li>
            <li>{t('reset_list_2')}</li>
            <li>{t('reset_list_3')}</li>
          </ul>
          <p>{t('reset_workspaces_confirmation_message2')}</p>
        </div>
      }
      loaderKey='workspace-reset'
    />
  );
});
